import { render, staticRenderFns } from "./RelatedBlock.vue?vue&type=template&id=70b8cbf4&scoped=true&"
import script from "./RelatedBlock.vue?vue&type=script&lang=js&"
export * from "./RelatedBlock.vue?vue&type=script&lang=js&"
import style0 from "./RelatedBlock.vue?vue&type=style&index=0&id=70b8cbf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8cbf4",
  null
  
)

export default component.exports